import React from 'react'

import { titles } from '../../constants'
import { getPrettyDate } from '../../utils'
import Metacritic from '../Metacritic/Metacritic'

import './DetailsPanel.css'
const DetailsPanel = ({ gameInfo }) => {
  let dp_sections = [
    'platforms',
    'released',
    'genres',
    'metacritic',
    'developers',
    'playtime',
    'tags'
  ]
  function populateSectionText(type, data) {
    if(type === 'released') {
      return getPrettyDate(data)
    }
    if(type === 'metacritic') {
      return <Metacritic metacritic={data}/>
    }
    if(typeof(data) === 'object'){
      if(type !== 'platforms'){
        let result = data.map(item => item.name)
        return result.join(', ')
      }
      else {
        let result = data.map(item => item.platform.name)
        return result.join(', ')
      }
    }
    return data
  }
  
  return (
    <div className="detailspanel">
        {dp_sections.map(item => {
          return(
            <div key={item} id={item} className="dp-section">
              <div className="section-title">{titles.titles[item]}</div>
              <div className="section-text">{populateSectionText(item, gameInfo[item])}</div>
            </div>
          )
        })}
    </div>
  )
}

export default DetailsPanel